export default "__VITE_ASSET__OhMpnC7L__"